import { AppRoutesNavigation, AppRoutesRouter } from '../../app-routes'
import { Group, Person } from '@mui/icons-material'

export const projectAdminSidebarItems = [
  {
    name: 'system-project-admin-users',
    path: AppRoutesNavigation.ProjectAdmin.users,
    icon: Person,
    pathname: AppRoutesRouter.ProjectAdmin.users,
  },
  {
    name: 'customers',
    path: AppRoutesNavigation.ProjectAdmin.customers,
    icon: Group,
    pathname: AppRoutesRouter.ProjectAdmin.customers,
  },
]
